import PropTypes from 'prop-types';

const activeProgramShape = {
  marketingUrl: PropTypes.string.isRequired,
  program: PropTypes.shape({
    authoringOrganizations: PropTypes.arrayOf(PropTypes.shape({
      key: PropTypes.string.isRequired,
    })).isRequired,
    courses: PropTypes.arrayOf(PropTypes.shape({
      course: PropTypes.shape({
        activeCourseRun: PropTypes.shape({
          isEnrollable: PropTypes.bool,
          key: PropTypes.string,
          marketingPath: PropTypes.string,
          maxEffort: PropTypes.number,
          minEffort: PropTypes.number,
          uuid: PropTypes.string,
          weeksToComplete: PropTypes.number,
        }).isRequired,
        marketingUrl: PropTypes.string.isRequired,
        subtitle: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
        uuid: PropTypes.string.isRequired,
      }).isRequired,
    })).isRequired,
    hidden: PropTypes.bool.isRequired,
    marketingPath: PropTypes.string.isRequired,
    marketingUrl: PropTypes.string.isRequired,
  }),
  title: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  uuid: PropTypes.string.isRequired,
};

export default activeProgramShape;
